const settingMediaGallery = {
  components: {
    FullImgPopup,
  },
  data() {
    return {
      gallery: {
        pos: 0,
        name: "image",
      },
      GIAImage: `${baseAssetsUrl}/gia.png`,
      VideoImage: `${baseAssetsUrl}/360video.jpg`,
      showPopupImg: false,
      zoomImgUrl: "",
      showLoader: false,
      isMobileDevice: false,
      opacity: { mid: 1, white: 1 },
      opacityInput: 0,
      slider: {
        min: 0,
        max: 80,
        step: 1,
      },
      video: "play",
      showLoaderGif: `${baseAssetsUrl}/loading_small.gif`,
      videoAvail: true,
    };
  },
  watch: {
    "$route.params.settingId": {
      handler(settingId) {
        if (settingId != undefined) {
          this.gallery.pos = 0;
          let name = this.$props.mediaGallery[this.gallery.pos].name;
          this.gallery.name = name;
        }
      },
    },
    showLoader: {
      handler(showLoader) {
        if (showLoader) {
          var timeoutId = setTimeout(() => {
            this.showLoader = false;
            clearTimeout(timeoutId);
          }, 4000);
        }
      },
    },
  },
  props: [
    "matchingBand",
    "mediaGallery",
    "placeholderShapes",
    "changeMetalOrDiamondLoading",
  ],
  delimiters: ["[[", "]]"],
  template: `#setting-media-gallery`,
  mounted() {
    if (window.innerWidth <= 767) {
      this.isMobileDevice = true;
    }
  },
  methods: {
    viewToMatchingBand() {
      document
        .querySelector("#matching-band-div")
        .scrollIntoView({ behavior: "smooth" });
    },
    handleVideoError() {
      this.videoAvail = false;
    },
    videoLoaded() {
      this.showLoader = false;
    },
    play_pause() {
      var x = document.getElementById("myVideo");
      if (this.video === "play") {
        x.pause();
        this.video = "pause";
      } else if (this.video === "pause") {
        this.video = "play";
        x.play();
      }
    },
    setPlaceholderImg(currentImg) {
      var placeholderShapes = this.$props.placeholderShapes?.value;
      var placeholderShape = placeholderShapes
        ?.split(",")
        .map((shape) => shape.trim())[0];
      currentImg.parentElement.style.display = "none";
      // currentImg.setAttribute("src", `${baseAssetsUrl}/diamond-ring.svg`)
    },
    setMainMedia(e, mediaPos, name) {
      if (name === "video") {
        this.video = "play";
        // this.showLoader = true
        this.videoAvail = true;
      }
      this.showLoader = true;
      this.gallery.pos = mediaPos;
      this.gallery.name = name;
    },
    showFullImgPopup() {
      this.showPopupImg = true;
      this.$refs.fullImg.setImageUrl(this.zoomImgUrl);
    },
  },
};

/* diamond meta data*/
const settingMetaData = {
  buySettingTooltipTxt: "Buy only setting without diamond",
  chooseSettingTooltipTxt: "Chose setting for build a ring",
  components: {
    DiamondHintPopupComp,
    DiamondEmailPopupComp,
    RequestDiamondImgPopupComp,
    TooltipComp,
    ChangeOptionPopupComp,
    SocialIconComp,
    StickyMobileBarComp,
  },
  data() {
    return {
      openHintPopup: false,
      openEmailPopup: false,
      openRequestDiamondImgPopup: false,
      buttonText: "Choose This Setting",
      buttonClicked: false,
      showBtnLoader: false,
      shipsByDate: "",
      showBtnTooltip: false,
      btnTooltipText: "",
      btnTooltipClass: "",
      showSocialIconDiv: false,
      tooltipIndex: "",
      tooltipType: "",
      // addToCartButtonShouldShow : true,
      productInWishList: this.$props.isInWishlist,
      loadingGIF: `${baseAssetsUrl}/loading.gif`,
      getDiamondShippingDays: "",
      coupon_ring_img: `${baseAssetsUrl}/coupon_studs.png`,
      isDDOpen: false,
      isSettingSizeValidate: false,
      isReadMore: false,
      activeKarat: '',
      /* "Apply free gift" opt-in (snippets/free-gift-vue.liquid). Shared with
         the diamond-detail and final-ring pages, the PDP and the cart through
         the same `apply_free_gift` flag -- sessionStorage only, so it dies
         with the tab and the box starts unticked next visit. */
      rbSettingGiftToggle: sessionStorage.getItem('apply_free_gift') === 'true',
    };
  },
  props: [
    "changeMetalOrDiamondLoading",
    "metalToChange",
    "diamondShape",
    "diamondShapes",
    "diamond",
    "isInWishlist",
    "wishlistText",
    "showTooltip",
    "wishlistClass",
    "settingMetalList",
    "metal",
    "settingSizesList",
    "settingSize",
    "selectedMetal",
    "selectedSettingSize",
    "showWishlistLoader",
    "settingCountry",
    "showSettingSizeDropdownClass",
    "showChangeSettingConfirm",
    "changeSettingWaringMsg",
    "initDiamondShape",
  ],
  emits: [
    "parentAddToWishlist",
    "update:metal-to-change",
    "update:diamond-shape",
    "update:setting-size",
    "addChooseSetting",
    "parentShowWarning",
    "update:setting-country",
    "resetSettingSize",
    "setFinalSize",
    "changeSetting",
  ],
  delimiters: ["[[", "]]"],
  template: `#setting-metadata`,
  mounted() {
    this.getSettingShippingDays();
    document.addEventListener("click", () => (this.isDDOpen = false));
    // this.addToCartButtonShouldShow = (!window.sessionStorage.getItem('selectedDiamond') && !window.sessionStorage.getItem('selectedSetting'))
    window.addEventListener("freeGiftToggleChanged", (e) => {
      if (this.rbSettingGiftToggle !== e.detail.checked) {
        this.rbSettingGiftToggle = e.detail.checked;
      }
    });
    /* A gift already in the cart means the shopper is opted in, whatever the
       stored flag says -- keep the box in step with the cart, not the other
       way round. */
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        var hasGift = cart.items && cart.items.some((i) => i.variant_id === 67834200031596 || (i.properties && i.properties._gift));
        if (hasGift) {
          this.rbSettingGiftToggle = true;
          sessionStorage.setItem("apply_free_gift", "true");
        }
      })
      .catch(() => {});
  },
  watch: {
    rbSettingGiftToggle(newVal) {
      var strVal = newVal ? 'true' : 'false';
      if (sessionStorage.getItem('apply_free_gift') !== strVal) {
        sessionStorage.setItem('apply_free_gift', strVal);
        window.dispatchEvent(new CustomEvent('freeGiftToggleChanged', { detail: { checked: newVal } }));
        /* Act on the real cart straight away, the way the PDP and the drawer
           do -- a cart that already clears the threshold gets the gift the
           moment the box is ticked, and loses it the moment it is unticked,
           instead of waiting for the shopper to reach /cart.
           (snippets/free-gift.liquid) */
        if (typeof window.ensureFreeGiftInCart === 'function') window.ensureFreeGiftInCart();
      }
    },
    "$route.params.settingId": {
      handler(settingId) {
        if (!!settingId) {
          this.buttonText = "Choose This Setting";
          this.buttonClicked = false;
          this.tooltipIndex = "";
          this.tooltipType = "";
          this.getShipsByDate();
        }
      },
      immediate: true,
    },
    metalToChange: {
      handler(metal) {
        if (metal) {
          const karat = metal.split(' ')[0];
          if (karat) this.activeKarat = karat;
        }
      },
      immediate: true,
    },
    availableKarats: {
      handler(karats) {
        if (!this.activeKarat && karats.length) {
          this.activeKarat = karats[0];
        }
      },
      immediate: true,
    },
  },
  computed: {
    availableKarats() {
      const order = ['9K', '14K', '18K', 'Platinum'];
      const present = new Set(this.$props.settingMetalList.map(m => m.split(' ')[0]));
      return order.filter(k => present.has(k));
    },
    metalsForActiveKarat() {
      if (!this.activeKarat) return [];
      return this.$props.settingMetalList.filter(m => m.startsWith(this.activeKarat));
    },
    getPopupTitle() {
      return this.$props.diamond.name;
    },
    getPopupImage() {
      return this.$props.diamond.main_image;
    },
    getPopupPlaceholderImage() {
      return this.$props.diamond.main_image;
    },
    getConfirmPopupTitle() {
      return (
        '"' +
        `${this.$props.diamond.name} in ${this.$props.selectedMetal}` +
        '"'
      );
    },
    getContactPhoneNumber() {
      return contactTelephoneNumber;
    },
    getTelephoneLink() {
      return `tel:${contactTelephoneNumber.replace(/[^0-9]/g, "")}`;
    },
    getShippingDays() {
      return engRingShippingDays;
    },
    getPageUrl() {
      return `${baseUrl}/collections/engagement-rings/settings/${this.$props.diamond.id}`;
    },
    getMetalFormattedLabel() {
      return (metalLabel) => {
        var labelTokens = metalLabel.split(" ");
        var newLabel =
          labelTokens.length > 1
            ? `${labelTokens[0].toUpperCase()}<br>${labelTokens
                .slice(1)
                .join(" ")}`
            : labelTokens.join(" ");
        return newLabel;
      };
    },
  },
  methods: {
    getColorLabel(metalLabel) {
      const tokens = metalLabel.split(' ');
      return tokens.length > 1 ? tokens.slice(1).join(' ') : metalLabel;
    },
    setActiveKarat(karat) {
      this.activeKarat = karat;
      if (!this.$props.metalToChange.startsWith(karat)) {
        const first = this.$props.settingMetalList.find(m => m.startsWith(karat));
        if (first && !this.$props.changeMetalOrDiamondLoading) {
          this.changeMetal(first);
        }
      }
    },
    /* Price the gift box measures against the threshold: the setting on its
       own, exactly as the price line above it renders it. Settings carry no
       lab/matching-band discount, hence a savings figure of 0 -- the box adds
       the gift's own worth to it. */
    settingGiftPrice() {
      var setting = this.$props.diamond;
      if (!setting || !setting.price) return 0;
      var price = parseFloat(
        String(this.adjustPriceByRingSize(this.$props.settingSize, setting.price)).replace(/,/g, "")
      );
      return isNaN(price) ? 0 : Math.round(price);
    },
    settingGiftSavings() {
      return 0;
    },
    adjustPriceByRingSize(ringSize, price) {
      return price;
      // Define ring sizes in order and the base size for comparison
      const ringSizes = [
        "Select Ring Size",
        "E",
        "E 1/2",
        "F",
        "F 1/2",
        "G",
        "G 1/2",
        "H",
        "H 1/2",
        "I",
        "I 1/2",
        "J",
        "J 1/2",
        "K",
        "K 1/2",
        "L",
        "L 1/2",
        "M",
        "M 1/2",
        "N",
        "N 1/2",
        "O",
        "O 1/2",
        "P",
        "P 1/2",
        "Q",
        "Q 1/2",
        "R",
        "R 1/2",
        "S",
        "S 1/2",
        "T",
        "T 1/2",
        "U",
        "U 1/2",
        "V",
        "V 1/2",
        "W",
        "W 1/2",
        "X",
        "X 1/2",
        "Y",
        "Y 1/2",
        "Z",
        "Z 1/2",
      ];
      const baseSize = "N"; // Base size threshold for price adjustment

      // Check if price is a string and clean up formatting if necessary
      let numericPrice =
        typeof price === "string"
          ? parseFloat(price.replace(/[^0-9.]/g, ""))
          : price;

      // Ensure the price is a valid number
      if (isNaN(numericPrice)) {
        // console.error("Invalid price input");
        return null; // Handle invalid price as needed
      }

      // Find indexes for the selected ring size and base size
      const ringSizeIndex = ringSizes.indexOf(ringSize);
      const baseSizeIndex = ringSizes.indexOf(baseSize);

      // Adjust the price if the ring size index is greater than or equal to the base size index
      return ringSizeIndex >= baseSizeIndex ? numericPrice + 20 : numericPrice;
    },
    toggleReadMore() {
      this.isReadMore = !this.isReadMore;
    },
    async copyCoupon(code) {
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.handleBtnTooltip("show", "copyCoupons");

      setTimeout(() => {
        this.handleBtnTooltip("hide", "copyCoupons");
      }, 2000);
    },
    addToWishListMetaData(settingId) {
      if (this.settingSize != "Select Ring Size") {
        this.$emit("parentAddToWishlist", settingId, this.settingSize);
      } else {
        this.handleBtnTooltip("show", "wishlist");
        setTimeout(() => {
          this.handleBtnTooltip("hide", "wishlist");
        }, 2000);
      }
    },
    openHintPopupForm() {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "Y9rtKH"]);
    },
    openDropDown(event) {
      event.stopPropagation();
      this.isDDOpen = true;
    },
    showIconSection() {
      if (this.showSocialIconDiv) {
        clearTimeout(this.iconTimeout); // Clear any existing timeout
        this.showSocialIconDiv = false;
      } else {
        this.showSocialIconDiv = true;
        this.iconTimeout = setTimeout(() => {
          this.showSocialIconDiv = false;
        }, 5000);
      }
    },
    getSettingShippingDays() {
      var week = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      var month = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let date = new Date(
        new Date(new Date()).setDate(new Date(new Date()).getDate() + 35)
      );
      this.getDiamondShippingDays = `${week[date.getDay()]}, ${
        month[date.getMonth()]
      } ${date.getDate()}`;
    },
    showSwatchTooltip(e, currentIndex, swatchType) {
      this.tooltipIndex = currentIndex;
      this.tooltipType = swatchType;
    },
    hideSwatchTooltip(e) {
      this.tooltipIndex = "";
      this.tooltipType = "";
    },
    changeMetal(metal) {
      sessionStorage.setItem("ring_size", this.settingSize);
      this.$emit("chooseMetal", metal);
    },
    changeDiamond(diamond) {
      sessionStorage.setItem("ring_size", this.settingSize);
      this.$emit("chooseDiamond", diamond);
    },
    changeCurrentOption(action) {
      this.$emit("changeSetting", action);
    },
    handleBtnTooltip(action, btnType) {
      var tooltipTxt;
      if (btnType == "buy") {
        tooltipTxt = action == "show" ? this.$options.buySettingTooltipTxt : "";
        btnTooltipClass = action == "show" ? "pc-buy-setting" : "";
      } else if (btnType == "copy") {
        tooltipTxt = action == "show" ? "Link Copied" : "";
        btnTooltipClass = action == "show" ? "pc-buy-setting" : "";
      } else if (btnType == "copyCoupons") {
        tooltipTxt = action == "show" ? "Coupon Code Copied!" : "";
        btnTooltipClass = action == "show" ? "pc-buy-diamond" : "";
      } else if (btnType == "wishlist") {
        tooltipTxt = action == "show" ? "Please Select Ring Size First" : "";
        btnTooltipClass = action == "show" ? "pc-buy-setting" : "";
      } else {
        tooltipTxt =
          action == "show" ? this.$options.chooseSettingTooltipTxt : "";
        btnTooltipClass = action == "show" ? "pc-choose-setting" : "";
      }
      this.btnTooltipText = tooltipTxt;
      this.btnTooltipClass = btnTooltipClass;
      this.showBtnTooltip = action == "show" ? true : false;
    },
    changeSetting(settingId) {
      this.$router.push({ name: "settingDetailPage", params: { settingId } });
    },
    addSetting(e) {
      if (this.settingSize == "Select Ring Size") {
        this.isSettingSizeValidate = true;
      } else {
        this.buttonText = "Adding . . .";
        // this.handleBtnTooltip("show","choose")
        this.$emit("addChooseSetting");
      }
    },
    setNewImage(targetElement, diamondShape) {
      targetElement.setAttribute(
        "src",
        `${baseAssetsUrl}/diamonds-${diamondShape.toLowerCase()}.svg`
      );
    },
    getShipsByDate() {
      var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];
      var daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var currentDate = new Date();
      var daysToAdd = 10;
      currentDate.setDate(currentDate.getDate() + parseInt(daysToAdd));
      this.shipsByDate = `${daysOfWeek[currentDate.getDay()]}, ${
        monthNames[currentDate.getMonth()]
      } ${currentDate.getDate()}`;
    },
    addToCart(e) {
      if (this.$props.selectedSettingSize.toLowerCase() == "select ring size") {
        this.$emit("parentShowWarning", "Select Ring Size");
        return;
      }
      this.$emit("parentShowWarning", "", true);
      this.buttonClicked = true;
      this.showBtnLoader = true;
      this.buttonText = "Adding in the cart...";
      e.target.style.pointerEvents = "none";
      setTimeout(() => {
        this.showBtnLoader = false;
        this.buttonClicked = false;
        this.buttonText = "Buy Setting Only";
        e.target.style.pointerEvents = "auto";
      }, 1500);
    },
    openFormPopup(e, formType) {
      if (formType === "drop_a_hint") {
        this.openHintPopup = true;
      } else if (formType === "email_us") {
        this.openEmailPopup = true;
      } else if (formType === "request_diamond_img") {
        this.openRequestDiamondImgPopup = true;
      }
    },
    redirectToAppointmentPage() {
      location.href = `${baseUrl}/book-an-appointment`;
    },
  },
};

/* diamond detail page */
const settingDetailTable = {
  props: ["settingDetails", "settingSizesList", "changeMetalOrDiamondLoading"],
  data() {
    return {
      qrcode: new QRious({ size: 90 }),
      isTooltipVisible: "",
    };
  },
  delimiters: ["[[", "]]"],
  template: `#setting-detail-table`,
  mounted() {
    // Add a click event listener to the document to close the tooltip
    document.addEventListener("click", () => (this.isTooltipVisible = ""));
  },
  beforeDestroy() {
    // Remove the event listener when the Vue component is destroyed
    document.removeEventListener("click", () => (this.isTooltipVisible = ""));
  },
  computed: {
    newQRCode() {
      this.qrcode.value = `${baseUrl}/collections/engagement-rings/settings/${this.$route.params.settingId}`;
      return this.qrcode.toDataURL();
    },
  },
  methods: {
    getShippingDays() {
      var week = [
        "Sunday",
        "Monday",
        "TuesDay",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      var month = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let date = new Date(
        new Date(new Date()).setDate(new Date(new Date()).getDate() + 10)
      );
      return `${week[date.getDay()]},${
        month[date.getMonth()]
      } ${date.getDate()}`;
    },
    setNewImage(targetElement, diamondShape) {
      targetElement.setAttribute(
        "src",
        `${baseAssetsUrl}/diamonds-${diamondShape.toLowerCase()}.svg`
      );
    },
    openPopup(e, num) {
      e.stopPropagation();
      this.isTooltipVisible = this.isTooltipVisible === num ? "" : num;
    },
  },
};

/* recently viewed setting component */
const RecentlyViewedItemsComp = {
  props: ["recentSettings"],
  delimiters: ["[[", "]]"],
  template: `#recently-viewed-settings`,
  data() {
    return {
      isMobileDevice: false,
      currentSlideIndex: 0,
      totalSlides: 0,
    };
  },
  mounted() {
    if (window.innerWidth <= 767) {
      this.isMobileDevice = true;
    }
  },
  updated() {
    this.totalSlides =
      this.$props.recentSettings.length == 0
        ? 0
        : this.$props.recentSettings.length - 1;
  },
  methods: {
    setNewImage(targetElement) {
      targetElement.setAttribute("src", `${baseAssetsUrl}/diamond-ring.svg`);
    },
    moveSlide(action) {
      var currentSlideIndex = this.currentSlideIndex;
      if (action == "prev") {
        currentSlideIndex--;
        if (currentSlideIndex < 0) {
          currentSlideIndex = this.totalSlides;
        }
      } else {
        currentSlideIndex++;
        if (currentSlideIndex > this.totalSlides) {
          currentSlideIndex = 0;
        }
      }
      this.currentSlideIndex = currentSlideIndex;
    },
    viewProduct(e, variantId) {
      this.$router.push({
        name: "settingDetailPage",
        params: { settingId: variantId },
      });
    },
  },
};

/* product detail component */
const SettingDetailPageComp = {
  components: {
    settingMediaGallery,
    settingMetaData,
    settingDetailTable,
    BreadcrumbsComp,
    DetailSpinnerComp,
    WishlistPopupComp,
    HeaderStepsComp,
    StickyBarComp,
    RecentlyViewedItemsComp,
  },
  data() {
    return {
      settingVideosMap: {},
      diamond: {
        diamondId: "",
        dataNotFound: false,
        data: {},
        attributes: {},
        mediaGallery: [],
        isInWishlist: false,
        wishlistText: "",
        wishlistClass: "",
        showTooltip: false,
        settingMetal: "",
        settingMetalToChange: "",
        settingMetalList: [],
        settingSize: "Select Ring Size",
        diamondShape: "",
        mainDiamondShape: "",
        diamondShapes: [],
      },
      isInWishlist: false,
      loading: false,
      breadcrumbs: [],
      recentlyViewSettings: [],
      uniqueItemInRecentView: true,
      showRecentlyView: true,
      showWishlistPopup: false,
      WishlistPopupContent: "",
      wishlistItemName: "",
      showWishlistLoader: false,
      defaultSettingCountry: "AUD",
      stepData: (function() {
        var fp = sessionStorage.getItem("firstPage");
        if (fp == "diamondPage") {
          return { firstStep: { headerTitle: "DIAMOND" }, secondStep: { headerTitle: "SETTING" }, thirdStep: { headerTitle: "Ring" } };
        }
        return { firstStep: { headerTitle: "SETTING" }, secondStep: { headerTitle: "DIAMOND" }, thirdStep: { headerTitle: "Ring" } };
      })(),
      totalSteps: 1,
      addsettingDropDownClass: false,
      pageStickyItems: [],
      showChangeSettingPopup: false,
      changeSettingWaringMsg: "",
      coupon_bangle_img: `${baseAssetsUrl}/bangles.png`,
      alexis: `${baseAssetsUrl}/alexis.png`,
      selectedDiamondArr: {},
      changeMetalOrDiamondLoading: false,
      redirectPage: "",
      matchingBand: [],
      mainImage: "",
      bandPlusRingBtnText: "Add To Cart",
      btnTooltipText: "",
      btnTooltipClass: "",
      showBtnTooltip: false,
    };
  },
  delimiters: ["[[", "]]"],
  template: `#setting-detail-page`,
  beforeUnmount() {
    handlePageBodyClass("remove", "pc-ringbuilder-setting-detail-page");
  },
  mounted() {
    this.handleBreadcrumbs();
    this.handleStepData();
    this.handleStickyBarItems();
    if (!!sessionStorage.getItem("redirection")) {
      this.redirectPage = sessionStorage
        .getItem("redirection")
        .includes("-diamonds")
        ? "DIAMOND"
        : "SETTING";
    }
    if (!sessionStorage.getItem("firstPage")) {
      sessionStorage.setItem("firstPage", "settingPage");
    }
    handlePageBodyClass("add", "pc-ringbuilder-setting-detail-page");

    this.resetWindowToTop();
    if (
      document.querySelector(
        "#header-banner .pc-top-banner-section picture img"
      )
    ) {
      document.querySelector(
        "#header-banner .pc-top-banner-section picture img"
      ).style.display = "none";
    }
  },
  watch: {
    "$route": {
      async handler(routeData) {
        if (!!routeData.query.variant) {
          this.handleStepData();
          this.handleStickyBarItems();
          this.initializeDiamondState(routeData);
          if (sessionStorage.getItem("selectedSetting")) {
            this.checkAndSetSettingDataFromSession();
          } else {
            // await this.loadDiamond();
          }
          this.checkAndSetSettingSizeOfSubVariations();
          // this.checkWishlist(settingId);
        }
      },
      immediate: true,
    },
    "diamond.settingMetalToChange": {
      handler() {
        this.handleMediaGallery(this.diamond.data);
      },
      immediate: true,
    },
  },
  computed: {
    getSettingSizes() {
      if (this.defaultSettingCountry == "US") {
        return [
          "Select Ring Size",
          "3",
          "3.25",
          "3.5",
          "3.75",
          "4",
          "4.25",
          "4.5",
          "4.75",
          "5",
          "5.25",
          "5.5",
          "5.75",
          "6",
          "6.25",
          "6.5",
          "6.75",
          "7",
          "7.25",
          "7.5",
          "7.75",
          "8",
          "8.25",
          "8.5",
          "8.75",
          "9",
          "9.25",
          "9.5",
          "9.75",
          "10",
          "10.25",
          "10.5",
          "10.75",
          "11",
          "11.25",
          "11.5",
          "11.75",
          "12",
          "12.25",
          "12.5",
          "12.75",
          "13",
          "13.25",
          "13.5",
          "13.75",
          "14",
          "14.25",
          "14.5",
          "14.75",
          "15",
        ];
      } else {
        return [
          "Select Ring Size",
          "E",
          "E 1/2",
          "F",
          "F 1/2",
          "G",
          "G 1/2",
          "H",
          "H 1/2",
          "I",
          "I 1/2",
          "J",
          "J 1/2",
          "K",
          "K 1/2",
          "L",
          "L 1/2",
          "M",
          "M 1/2",
          "N",
          "N 1/2",
          "O",
          "O 1/2",
          "P",
          "P 1/2",
          "Q",
          "Q 1/2",
          "R",
          "R 1/2",
          "S",
          "S 1/2",
          "T",
          "T 1/2",
          "U",
          "U 1/2",
          "V",
          "V 1/2",
          "W",
          "W 1/2",
          "X",
          "X 1/2",
          "Y",
          "Y 1/2",
          "Z",
          "Z 1/2",
        ];
      }
    },
    getBannerImgUrl() {
      return `${baseAssetsUrl}/got_question_banner.jpg`;
    },
    getDetailPageBannerUrl() {
      return `${baseAssetsUrl}/diamonds-banner.jpg`;
    },
  },
  methods: {
    functionOnConnect() {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "Xyi5kc"]);
    },
    resetAllSteps() {
      this.stepData = {
        firstStep: {
          headerTitle: "SETTING",
        },
        secondStep: {
          headerTitle: "DIAMOND",
        },
        thirdStep: {
          headerTitle: "Ring",
        },
      };
    },
    openInfo(e) {
      let element;
      if (e.target.nodeName == "svg") {
        element = e.target.parentElement;
        e.target.parentElement.classList.toggle("active");
      } else {
        element = e.target;
        e.target.classList.toggle("active");
      }
      var panel = element.nextElementSibling;
      if (
        Array.from(element.parentElement.classList).includes("accordion-active")
      ) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
      element.classList.toggle("active");
      element.parentElement.classList.toggle("accordion-active");
      element.parentElement.classList.toggle("accordion-non-active");
    },
    setChosenMetal(chosenMetal) {
      this.diamond.settingMetalToChange = chosenMetal;
      this.checkAndLoadNewSetting(chosenMetal.trim(), "");
    },
    setChosenDiamond(chosenShape) {
      this.diamond.diamondShape = chosenShape;
      this.checkAndLoadNewSetting("", chosenShape.trim());
    },
    checkAndLoadNewSetting(chosenMetal = "", chosenDiamond = "") {
      var metal = chosenMetal != "" ? chosenMetal : this.diamond.settingMetal;
      var diamond =
        chosenDiamond != "" ? chosenDiamond : this.diamond.diamondShape;
      var settingVariations = this.diamond.data.variations;
      var settingId;
      for (var settingSlug in settingVariations) {
        if (
          settingVariations[settingSlug].metal.toLowerCase() ==
            metal.toLowerCase() &&
          settingVariations[settingSlug].diamond.toLowerCase() ==
            diamond.toLowerCase()
        ) {
          settingId = settingVariations[settingSlug].variation_id;
          break;
        }
      }
      if (!settingId) {
        this.initializedSettingConfigOptions(chosenMetal, chosenDiamond);
      } else {
        sessionStorage.setItem(
          "settingMetal",
          JSON.stringify(this.diamond.settingMetalList)
        );
        sessionStorage.setItem(
          "settingDiamond",
          JSON.stringify(this.diamond.diamondShapes)
        );
        sessionStorage.setItem("changeMetalOrDiamond", true);
        this.$router.push({ path: `/collections/engagement-rings/settings/${settingId}` });
      }
    },
    initializedSettingConfigOptions(chosenMetal = "", chosenDiamond = "") {
      var settingVariations = this.diamond.data.variations;
      var settingId;
      for (var settingSlug in settingVariations) {
        if (chosenMetal != "") {
          if (
            chosenMetal.toLowerCase() ==
            settingVariations[settingSlug].metal.toLowerCase()
          ) {
            settingId = settingVariations[settingSlug].variation_id;
            break;
          }
        } else {
          if (
            chosenDiamond.toLowerCase() ==
            settingVariations[settingSlug].diamond.toLowerCase()
          ) {
            settingId = settingVariations[settingSlug].variation_id;
            break;
          }
        }
      }
      this.$router.push({ name: "settingDetailPage", params: { settingId } });
    },
    checkAndSetSettingSizeOfSubVariations() {
      if (sessionStorage.getItem("selectedSetting")) {
        var settingData = JSON.parse(sessionStorage.getItem("selectedSetting"));
        var settingConfigOptions = JSON.parse(
          sessionStorage.getItem("selectedSettingOptions")
        );
        for (var settingSlug in settingData.variations) {
          if (
            settingData.variations[settingSlug].variation_id ==
            this.diamond.diamondId
          ) {
            this.diamond.settingSize = settingConfigOptions.settingSize;
            this.defaultSettingCountry = settingConfigOptions.settingCountry;
            break;
          }
        }
      }
    },
    startWith(pageType) {
      if (pageType == "setting") {
        this.$router.push({
          name: "chooseSetting",
          query: { pageType: "setting" },
        });
      } else {
        this.$router.push({
          name: "chooseDiamonds",
          query: { pageType: "diamond" },
        });
      }
    },
    async checkAndSetSettingDataFromSession() {
      var settingData = JSON.parse(sessionStorage.getItem("selectedSetting"));
      if (this.diamond.diamondId == settingData.id) {
        let attributes = {};
        let metalType;
        if (!!settingData.sku) {
          attributes["SKU"] = {
            value: settingData.sku,
            description: "sku is here",
          };
          if (settingData.sku.includes("14K-W")) {
            metalType = "14KT White Gold";
          } else if (settingData.sku.includes("18K-W")) {
            metalType = "18KT White Gold";
          } else if (settingData.sku.includes("14K-Y")) {
            metalType = "14KT Yellow Gold";
          } else if (settingData.sku.includes("18K-Y")) {
            metalType = "18KT Yellow Gold";
          } else if (settingData.sku.includes("14K-R")) {
            metalType = "14KT Rose Gold";
          } else if (settingData.sku.includes("18K-R")) {
            metalType = "18KT Rose Gold";
          } else if (settingData.sku.includes("P-W")) {
            metalType = "Platinum";
          }
          attributes["Metal"] = {
            value: metalType,
            description: "metal type is here",
          };
        }
        Object.keys(settingData.attributes).forEach((v, i) => {
          let obj = {};
          if (v == "Approx._Ring_Weight") {
            obj["value"] = settingData.attributes[v];
            obj["description"] = "Ring Weight is here";
            attributes["Setting Weight"] = obj;
          } else if (v == "Engagement_Ring_Metal_Type") {
            obj["value"] = settingData.attributes[v];
            obj["description"] = "Ring Metal type is here";
            attributes[v] = obj;
          } else if (v == "Engagement_Ring_Style") {
            obj["value"] = settingData.attributes[v];
            obj["description"] = "Ring Metal type is here";
            obj["alias"] = "Style";
            attributes["Setting Style"] = obj;
          } else if (v == "This_Ring_Can_Be_Set_With") {
            obj["alias"] = "Set With";
            // obj["value"] = settingData.attributes[v]?.replaceAll(",", ", ");
            obj["description"] = "Ring Metal type is here";
            attributes["Can Be Set With"] = obj;
          }
        });
        this.loading = true;
        this.diamond.data = settingData;
        this.matchingBand = settingData.matching_band.every(
          (innerArray) => Array.isArray(innerArray) && innerArray.length === 0
        )
          ? []
          : settingData.matching_band;
        this.mainImage = settingData.images[0].src;
        this.handleMediaGallery(settingData);
        this.handleMetaList(
          settingData.attribute_variations[engagement_ring_metal_type]
        );
        this.handleDiamondShape(
          settingData.attribute_variations[this_ring_can_be_set_with]
        );
        this.setCurrentConfigOptions(settingData.variations);
        this.handleRecentlyViewedItems({ ...settingData, ...attributes });
        this.diamond.attributes = attributes;
        // this.diamond.attributes = settingData.attributes
        this.handleMetaData();
        this.handleBreadcrumbs();
        this.loading = false;
      } else {
        // await this.loadDiamond();
      }
    },
    getConvertedSetting(setting) {
      var setting = getCurrencyWiseSetting(setting);
      return setting;
    },
    setFinalRingSize(ringSize) {
      if (sessionStorage.getItem("selectedSettingOptions")) {
        var settingOptions = JSON.parse(
          sessionStorage.getItem("selectedSettingOptions")
        );
        settingOptions.settingCountry = this.defaultSettingCountry;
        settingOptions.settingSize = ringSize;
        sessionStorage.setItem(
          "selectedSettingOptions",
          JSON.stringify(settingOptions)
        );
      }
    },
    initializeSettingSize() {
      this.diamond.settingSize = "Select Ring Size";
      if (sessionStorage.getItem("selectedSetting")) {
        var settingData = JSON.parse(sessionStorage.getItem("selectedSetting"));
        var settingConfigOptions = JSON.parse(
          sessionStorage.getItem("selectedSettingOptions")
        );
        for (var settingSlug in settingData.variations) {
          if (
            settingData.variations[settingSlug].variation_id ==
              this.diamond.diamondId &&
            this.defaultSettingCountry == settingConfigOptions.settingCountry
          ) {
            this.diamond.settingSize = settingConfigOptions.settingSize;
          }
        }
      }
    },
    showWarningMsg(warningMsg, showOnlySettingSizeError = false) {
      if (!showOnlySettingSizeError) {
        this.diamond.showTooltip = true;
        this.diamond.wishlistText = warningMsg;
        this.diamond.wishlistClass = "";
        this.addsettingDropDownClass = true;
        setTimeout(() => {
          this.diamond.showTooltip = false;
        }, 2000);
      } else {
        this.addsettingDropDownClass = false;
      }
    },
    resetWindowToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    checkSettingsSelectedOptions(settingId) {
      if (sessionStorage.getItem("selectedSettingOptions") != null) {
        const settingOptions = JSON.parse(
          sessionStorage.getItem("selectedSettingOptions")
        );
        if (settingOptions.settingId == settingId) {
          this.diamond.settingSize = settingOptions.settingSize;
          this.defaultSettingCountry = settingOptions.settingCountry;
        }
      }
    },
    addCurrentSetting() {
      if (this.diamond.settingSize.toLowerCase() == "select ring size") {
        this.diamond.showTooltip = true;
        if (window.innerWidth < 510) {
          this.diamond.wishlistText = "↑ * Select Ring Size";
        } else {
          this.diamond.wishlistText = "← * Select Ring Size";
        }

        this.diamond.wishlistClass = "pc-text-red";
        this.addsettingDropDownClass = true;
        setTimeout(() => {
          this.diamond.showTooltip = false;
        }, 2000);
        return;
      } else {
        this.diamond.wishlistClass = "";
        this.addsettingDropDownClass = false;
      }

      /* check selected setting is compatible with selected diamond or not if available */
      var settingCanBeSetWith = this.diamond.data?.options[1].values.length
        ? this.diamond.data?.options[1].values?.map((shape) => shape.trim())
        : [];
      if (
        sessionStorage.getItem("selectedDiamond") &&
        settingCanBeSetWith.length
      ) {
        var selectedDiamond = JSON.parse(
          sessionStorage.getItem("selectedDiamond")
        );
        var diamondShape = selectedDiamond.shape.trim();
        if (!settingCanBeSetWith.includes(diamondShape)) {
          this.showChangeSettingPopup = true;
          this.changeSettingWaringMsg = this.getWarningMsg(diamondShape);
        } else if (
          this.diamond.diamondShape != null &&
          this.diamond.diamondShape.trim().toLowerCase() !=
            diamondShape.toLowerCase()
        ) {
          this.showChangeSettingPopup = true;
          this.changeSettingWaringMsg = this.getWarningMsg(diamondShape);
        } else {
          this.checkAndResetSelectedDiamond(0);
        }
      } else {
        this.checkAndResetSelectedDiamond(0);
      }
    },
    getWarningMsg(diamondShape) {
      return `The ${diamondShape} shape diamond which you have selected is not compatible with `;
    },
    setNewImage(targetElement, diamondShape) {
      targetElement.setAttribute(
        "src",
        `${baseAssetsUrl}/diamonds-${diamondShape.toLowerCase()}.svg`
      );
    },
    initializeDiamondState(settingId) {
      var diamond = this.diamond;
      diamond.id = settingId;
      diamond.dataNotFound = false;
      diamond.mediaGallery = [];
      diamond.isInWishlist = false;
      diamond.wishlistText = "";
      diamond.showTooltip = false;
      diamond.wishlistClass = "";
      diamond.settingMetalList = [];
      diamond.diamondShapes = [];
      diamond.settingSize = "Select Ring Size";
      // this.defaultSettingCountry = "US";
      this.defaultSettingCountry = "AUD";
      this.breadcrumbs = [];
      this.recentlyViewSettings = [];
      this.uniqueItemInRecentView = true;
      if (window.innerWidth <= 676) {
        this.showRecentlyView = false;
      }
    },
    handleBreadcrumbs() {
      this.breadcrumbs = [];
      const settingId = this.$route.params.settingId;
      const readyToShip = window.roaReadyToShip || {};
      const isReadyToShip =
        Array.isArray(readyToShip.handles) && readyToShip.handles.includes(settingId);

      const collectionPath = isReadyToShip
        ? readyToShip.collectionUrl || "/collections/ready-to-ship"
        : "/collections/engagement-rings";

      const chooseSettingsListingUrl = {
        path: collectionPath,
        name: isReadyToShip
          ? readyToShip.title || "Ready to Ship"
          : "Engagement Rings",
      };
      this.breadcrumbs.push(chooseSettingsListingUrl);

      var rawTitle =
        this.diamond?.data?.name || document.title || settingId || "Setting Details";
      var chooseSettingsName = String(rawTitle)
        .replace(/^(Shop|Buy)\s+/i, "")
        .replace(/\s*[\-\|\u2013\u2014]\s*Rings of Australia.*/i, "")
        .replace(/\s+Engagement Rings Online Now/i, "")
        .replace(/\s+Online$/i, "")
        .replace(/\.+$/, "")
        .trim() || "Setting Details";

      var settingname = localStorage.getItem("settingname");
      if (!settingname || settingname === "settings" || settingname === "engagement-rings") {
        const knownStyles = [
          { key: "hidden-halo", matches: ["hidden halo", "hidden-halo"] },
          { key: "toi-et-moi", matches: ["toi et moi", "toi-et-moi"] },
          { key: "nature-inspired", matches: ["nature inspired", "nature-inspired"] },
          { key: "three-stone", matches: ["three stone", "three-stone"] },
          { key: "side-stone", matches: ["side stone", "side-stone"] },
          { key: "solitaire", matches: ["solitaire"] },
          { key: "bezel", matches: ["bezel"] },
          { key: "halo", matches: ["halo"] },
          { key: "pave", matches: ["pave", "pavé"] },
          { key: "vintage", matches: ["vintage"] },
          { key: "unique", matches: ["unique"] },
        ];

        // 1. Check attributes
        var styleVal =
          this.diamond?.attributes?.["Setting Style"]?.value ||
          this.diamond?.attributes?.Engagement_Ring_Style?.value ||
          this.diamond?.data?.attributes?.Engagement_Ring_Style ||
          (this.diamond?.data?.attributes?.["Setting Style"] && this.diamond.data.attributes["Setting Style"].value);

        if (styleVal && typeof styleVal === "string") {
          const lower = styleVal.toLowerCase();
          for (const style of knownStyles) {
            if (style.matches.some((m) => lower.includes(m))) {
              settingname = style.key;
              break;
            }
          }
        }

        // 2. Check tags
        if (!settingname && Array.isArray(this.diamond?.data?.tags)) {
          const tagsLower = this.diamond.data.tags.map((t) => String(t).toLowerCase());
          for (const style of knownStyles) {
            if (style.matches.some((m) => tagsLower.some((t) => t.includes(m)))) {
              settingname = style.key;
              break;
            }
          }
        }

        // 3. Check product title if still not detected
        if (!settingname && chooseSettingsName) {
          const lowerTitle = chooseSettingsName.toLowerCase();
          for (const style of knownStyles) {
            if (style.matches.some((m) => lowerTitle.includes(m))) {
              settingname = style.key;
              break;
            }
          }
        }
      }

      if (!isReadyToShip && settingname && settingname !== "settings" && settingname !== "engagement-rings") {
        var cleanName = settingname
          .replace(/-engagement-rings$/i, "")
          .replace(/^engagement-rings-/i, "")
          .split("-")
          .join(" ")
          .split(" ")
          .filter(Boolean)
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");

        var styleBreadcrumbName = cleanName.toLowerCase().includes("engagement ring")
          ? cleanName
          : `${cleanName} Engagement Rings`;

        this.breadcrumbs.push({
          path: `${collectionPath}/${settingname}`,
          name: styleBreadcrumbName,
        });
      }

      const chooseSettingUrl = {
        path: `${collectionPath}/products/${settingId}`,
        name: chooseSettingsName,
      };
      this.breadcrumbs.push(chooseSettingUrl);
    },
    addToWishlist(settingId, settingSize) {
      this.showWishlistLoader = true;
      setTimeout(() => {
        this.showWishlistLoader = false;
        var wishlistItems = localStorage.getItem("wishlistItems")
          ? JSON.parse(localStorage.getItem("wishlistItems"))
          : [];
        if (!wishlistItems.includes(settingId)) {
          wishlistItems.push(settingId);
          sessionStorage.setItem("status", "Great choice! This product has been added to your wishlist.");
        } else {
          sessionStorage.setItem("status", "Already exist in your wishlist");
        }
        localStorage.setItem("wishlistItems", JSON.stringify(wishlistItems));
        this.diamond.isInWishlist = true;
        this.showWishlistPopup = true;
        this.wishlistItemName = this.diamond.data.name;
      }, 300);
    },
    checkWishlist(settingId) {
      const wishlistItems =
        localStorage.getItem("wishlistItems") != null
          ? JSON.parse(localStorage.getItem("wishlistItems"))
          : "";
      if (wishlistItems.length) {
        wishlistItems.map((storedWishlistSettingId) => {
          if (storedWishlistSettingId == settingId) {
            this.diamond.isInWishlist = this.isInWishlist = true;
          }
        });
      }
      sessionStorage.setItem("checkSettingId", settingId);
    },
    goBack() {
      sessionStorage.setItem(
        "settingDetailPageViewedId",
        this.diamond.diamondId
      );
      var settingname = localStorage.getItem("settingname");

      /* if (sessionStorage.getItem("firstPage")) {
                var firstPage = sessionStorage.getItem("firstPage")
                if (firstPage == 'diamondPage') {
                    this.$router.push({name : "chooseSetting"})                                                
                } else {
                    this.$router.push({name : "chooseSetting", query : {'pageType' : 'setting'}})                            
                }
                return     
            } */
      // this.$router.push({
      //   path: `/engagement-rings${settingname ? `/${settingname}` : ""}`,
      // });
      window.location.href = `/collections/engagement-rings${settingname ? `/${settingname}` : ""}`
      // this.$router.push({name : "chooseSetting", query : {'pageType' : 'setting'}})
    },
    async loadDiamond() {

      if (sessionStorage.getItem("changeMetalOrDiamond")) {
        this.loading = false;
        this.changeMetalOrDiamondLoading = true;
      } else {
        this.loading = true;
      }
      if (!!sessionStorage.getItem("settingMetal")) {
        this.diamond.settingMetalList = JSON.parse(
          sessionStorage.getItem("settingMetal")
        );
      }
      if (!!sessionStorage.getItem("settingDiamond")) {
        this.diamond.diamondShapes = JSON.parse(
          sessionStorage.getItem("settingDiamond")
        );
      }
      if (sessionStorage.getItem("ring_size")) {
        this.diamond.settingSize = sessionStorage.getItem("ring_size");
      }

      const productId = `gid://shopify/Product/${this.diamond.id}`; // Replace with your actual product ID
      const storefrontAccessToken = window.ShopifyConfig.storefrontAccessToken; // Replace with your Storefront API token

      const query = `
          {
             product(id: "${productId}") {
                description
                descriptionHtml
                featuredImage {
                    altText
                    height
                    id
                    originalSrc
                    src
                    transformedSrc
                    url
                    width
                }
                id
                images(first: 10) {
                    nodes {
                        altText
                        id
                        src
                    }
                }
                options {
                    id
                    name
                    values
                    optionValues {
                        id
                        name
                    }
                }
                priceRange {
                    maxVariantPrice {
                        amount
                        currencyCode
                    }
                    minVariantPrice {
                        amount
                        currencyCode
                    }
                }
                productType
                title
                variants(first: 10) {
                    nodes {
                        availableForSale
                        barcode
                        currentlyNotInStock
                        id
                        quantityAvailable
                        requiresComponents
                        requiresShipping
                        sku
                        taxable
                        title
                        weight
                        weightUnit
                        compareAtPrice {
                            amount
                            currencyCode
                        }
                        compareAtPriceV2 {
                            amount
                            currencyCode
                        }
                        price {
                            amount
                            currencyCode
                        }
                    }
                }
                vendor
                variantsCount {
                    count
                    precision
                }
                media(first: 10) {
                    nodes {
                        previewImage {
                            altText
                            height
                            id
                            originalSrc
                            src
                            transformedSrc
                            url
                            width
                        }
                        id
                        alt
                    }
                }
                productVideosMetafield: metafield(namespace: "custom", key: "product_videos") {
                    value
                }
            }
          }
      `;
      axios
        .post(
          // Matches the same theme-proxied, no-token endpoint pattern used by
          // ring-builder-choose-settings.js (the settings-listing page): Shopify
          // serves storefront GraphQL through /api/<version>/graphql.json without
          // requiring a Storefront API access token. The previous URL was missing
          // the ".json" suffix and relied on window.ShopifyConfig.storefrontAccessToken,
          // which is never set (commented out in layout/theme.liquid).
          "/api/2026-04/graphql.json",
          { query: query },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          const product = response?.data?.data?.product || [];
          if (Object.keys(product).length) {
            sessionStorage.removeItem("changeMetalOrDiamond");
        
            if (this.changeMetalOrDiamondLoading) {
              this.changeMetalOrDiamondLoading = false;
            }
            let attributes = {};
            let metalType;
            if (product?.variantsCount?.count) {
              attributes["SKU"] = {
                value: product.id,
                description: "sku is here",
              };
              const metalTypes = product?.options[0]?.values || [];
              if (metalTypes?.includes("14K White")) {
                metalType = "14KT White Gold";
              } else if (metalTypes?.includes("18K White")) {
                metalType = "18KT White Gold";
              } else if (metalTypes?.includes("14K Yellow")) {
                metalType = "14KT Yellow Gold";
              } else if (metalTypes?.includes("18K Yellow")) {
                metalType = "18KT Yellow Gold";
              } else if (metalTypes?.includes("14K Rose")) {
                metalType = "14KT Rose Gold";
              } else if (metalTypes?.includes("18K Rose")) {
                metalType = "18KT Rose Gold";
              } else if (metalTypes?.includes("Platinum")) {
                metalType = "Platinum";
              }
              attributes["Metal"] = {
                value: metalType,
                description:
                  "What colour and karat the setting will be crafted with",
              };
            }
            // Object.keys(response.data.options).forEach((v, i) => {
            //   let obj = {};
            //   /* if(v == 'Approx._Ring_Weight'){
            //                 obj['value'] = response.data.attributes[v]
            //                 obj['description'] ='This is the total carat weight of all the accent diamonds collectively in the setting'
            //                 attributes['Setting Weight'] = obj
            //             } else if( v == 'Engagement_Ring_Metal_Type') {
            //                 obj['value'] = response.data.attributes[v]
            //                 obj['description'] ='Ring Metal type is here'
            //                 attributes[v] = obj
            //             } else */ if (v == "Engagement_Ring_Style") {
            //     obj["alias"] = "Style";
            //     obj["value"] = response.data.attributes[v];
            //     obj["description"] =
            //       "General design category of the ring that will hold the center diamond";
            //     attributes["Setting Style"] = obj;
            //   } else if (v == "This_Ring_Can_Be_Set_With") {
            //     obj["alias"] = "Set With";
            //     obj["value"] = response.data.attributes[v]?.replaceAll(
            //       ",",
            //       ", "
            //     );
            //     obj["description"] =
            //       "Some settings are specifically crafted around a certain shape diamond, the shapes shown here can be set with this style ring";
            //     attributes["Can Be Set With"] = obj;
            //   }
            // });
        
            this.diamond.dataNotFound = false;
            product.currency = currencySymbol || "$"
            product.id = this.diamond.id;
            product.name = product.title;
            this.diamond.data = {...this.diamond.data ,...product}
            // This route fetches setting data via the Storefront GraphQL API rather
            // than a Liquid-rendered product page, so it has no access to the
            // window.currentProductVideoUrl / #product-video globals custom-video-player.js
            // maintains on a classic product page. Parse the product_videos metafield
            // straight from this same response instead.
            try {
              this.settingVideosMap = JSON.parse(product?.productVideosMetafield?.value || "{}") || {};
            } catch (e) {
              this.settingVideosMap = {};
            }
            // this.matchingBand = product.matching_band.every(
            //   (innerArray) =>
            //     Array.isArray(innerArray) && innerArray.length === 0
            // )
            //   ? []
            //   : product.matching_band;
            this.mainImage = product.featured_image;
            if (!!product?.media || !!product?.video) {
              this.handleMediaGallery(
                product
              );
            }
            if (sessionStorage.getItem("settingMetal") == null) {
              this.handleMetaList(
                product.options[0].values
              );
            }
            if (sessionStorage.getItem("settingDiamond") == null) {
              this.handleDiamondShape(
                product.options[1].values
              );
            }
        
            // this.setCurrentConfigOptions(response.data.variants);
            // this.handleRecentlyViewedItems({
            //   ...this.diamond?.data,
            // });
            this.handleMetaData();
            this.handleBreadcrumbs();
          } else {
            window.location.href = "/collections/engagement-rings";
            this.diamond.dataNotFound = true;
            this.handleMetaData();
            this.handleBreadcrumbs();
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error("error in fetching diamond details", err);
          window.location.href = "/collections/engagement-rings";
          this.diamond.data = {};
          this.diamond.dataNotFound = true;
          this.loading = false;
          this.handleMetaData();
          this.handleBreadcrumbs();
        });
    },
    handleRecentlyViewedItems(settingData) {
      var recentItems = [];
      var settingExist = false;
      if (sessionStorage.getItem("recentlyViewSettings")) {
        recentItems = JSON.parse(
          sessionStorage.getItem("recentlyViewSettings")
        );
      }
      if (recentItems.length) {
        recentItems.forEach((recentItem) => {
          if (recentItem.productId == settingData.parent_product_id) {
            settingExist = true;
          }
        });
      }

      if (!settingExist) {
        let skuArr = settingData.sku.split("-");
        var itemJSON = {
          productId: settingData.parent_product_id,
          variantId: settingData.id,
          title: settingData.name,
          img: settingData.main_image,
          metal: settingData.Metal.value,
          diamondShape: skuArr[skuArr.length - 1],
          currency: settingData.currency,
        };
        itemJSON = appendCurrenciesToRecentlyViewedSettings(
          itemJSON,
          settingData
        );
        recentItems.push(itemJSON);
      }
      if (recentItems.length > 5) recentItems.shift();
      sessionStorage.setItem(
        "recentlyViewSettings",
        JSON.stringify(recentItems)
      );
      this.setFilteredRecentSettings(recentItems, settingData);
    },
    setFilteredRecentSettings(recentSettings, curSetting) {
      var recentItems = recentSettings.filter((recentItem) => {
        return recentItem.productId != curSetting.parent_product_id;
      });
      if (recentItems.length) {
        recentItems.forEach((recentItem) => {
          recentItem = getCurrencyWiseRecentSetting(recentItem);
        });
        this.recentlyViewSettings.push(...recentItems);
      }
    },
    changeCurrentSetting(action) {
      if (action == "yes") {
        sessionStorage.removeItem("isDiamondDetailPageViewed");
        this.checkAndResetSelectedDiamond(1);
        this.showChangeSettingPopup = false;
      } else {
        this.checkAndSendToFinalPage();
      }
    },
    checkAndSendToFinalPage() {
      firstPage = sessionStorage.getItem("firstPage");
      if (
        sessionStorage.getItem("selectedDiamond") != null &&
        sessionStorage.getItem("selectedSetting") != null
      ) {
        var selectedSetting = JSON.parse(
          sessionStorage.getItem("selectedSetting")
        );
        var selectedDiamond = JSON.parse(
          sessionStorage.getItem("selectedDiamond")
        );
        var settingId = selectedSetting.id;
        var diamondId = selectedDiamond.diamondId;
        var diamondType = selectedDiamond.diamondType;
        // buildFinalRingUrl (ring-builder-common-components.js) is the single source
        // of truth for this URL's shape; a hard navigation (not router.push) is
        // required to cross the base-path boundary reliably, same as handleSettingMsgAndRout.
        var href = buildFinalRingUrl({ settingId, diamondId, diamondType });
        if (href) window.location.href = `${baseUrl}${href}`;
      } else {
        this.showChangeSettingPopup = false;
      }
    },
    checkAndResetSelectedDiamond(resetDiamond) {
      var isSelectedDiamondRested = 0;
      if (sessionStorage.getItem("selectedDiamond") && resetDiamond) {
        var selectedDiamond = JSON.parse(
          sessionStorage.getItem("selectedDiamond")
        );
        var diamondType = selectedDiamond.diamondType.trim();
        /* reset steps */
        this.resetSteps();
        /* remove diamond from session storage */
        this.selectedDiamondArr = JSON.parse(
          sessionStorage.getItem("selectedDiamond")
        );
        sessionStorage.removeItem("selectedDiamond");
        /* remove sticky bar */
        sessionStorage.removeItem("stickyBarItems");
        /* remove step data */
        sessionStorage.removeItem("stepData");
        /* remove diamond listing applied filters */
        sessionStorage.removeItem(`${diamondType}DiamondsAppliedFilters`);
        /* handle step data and sticky bar items */
        this.handleStepData(this.diamond.data);
        this.handleStickyBarItems(this.diamond.data);
        isSelectedDiamondRested = 1;
      } else {
        /* handle step data and sticky bar items */
        this.handleStepData(this.diamond.data);
        this.handleStickyBarItems(this.diamond.data);
        isSelectedDiamondRested = 0;
      }
      this.saveCurrentSetting();
      this.handleSettingMsgAndRout(isSelectedDiamondRested);
    },
    resetSteps() {
      var firstPage = sessionStorage.getItem("firstPage");
      if (firstPage == "diamondPage") {
        this.stepData = {
          firstStep: { headerTitle: "DIAMOND" },
          secondStep: { headerTitle: "SETTING" },
          thirdStep: { headerTitle: "Ring" },
        };
      } else {
        this.stepData = {
          firstStep: { headerTitle: "SETTING" },
          secondStep: { headerTitle: "DIAMOND" },
          thirdStep: { headerTitle: "Ring" },
        };
      }
    },
    /* Mirrors custom-video-player.js's getVideoKey(): option1's metal word +
       option2 (diamond shape), lowercased, with "platinum" normalised to "white"
       since platinum settings share the white-gold video. settingMetal/diamondShape
       here are this component's equivalent of a variant's option1/option2. */
    getCurrentSettingVideoUrl() {
      var map = this.settingVideosMap;
      if (!map || typeof map !== "object") return null;
      var mapKeys = Object.keys(map);
      if (!mapKeys.length) return null;

      var metal = this.diamond.settingMetal || "";
      var metalParts = metal.trim().split(" ").filter(Boolean);
      var metalWord = metalParts.length > 1 ? metalParts[1].toLowerCase() : (metalParts[0] || "").toLowerCase();
      if (metalWord === "platinum") metalWord = "white";
      var shape = (this.diamond.diamondShape || "").trim().toLowerCase();

      // Try exact metal+shape (matches getVideoKey exactly), then metal-only,
      // then shape-only, then any key merely containing the metal word — settingMetal/
      // diamondShape are populated by this page's own UI state rather than a real
      // variant's option1/option2, so their exact wording relative to the metafield's
      // keys isn't guaranteed; degrade gracefully instead of returning nothing.
      var candidates = [];
      if (metalWord && shape) candidates.push(metalWord + shape);
      if (metalWord) candidates.push(metalWord);
      if (shape) candidates.push(shape);
      for (var i = 0; i < candidates.length; i++) {
        if (Object.prototype.hasOwnProperty.call(map, candidates[i])) return map[candidates[i]];
      }
      if (metalWord) {
        var partial = mapKeys.find(function (k) { return k.indexOf(metalWord) !== -1; });
        if (partial) return map[partial];
      }
      return null;
    },
    saveCurrentSetting() {
      /* set selected setting's data in session storage */
      sessionStorage.setItem(
        "selectedSetting",
        JSON.stringify(this.diamond.data)
      );
      sessionStorage.removeItem("redirection");

      /* Save the setting's video if the page has one. This route loads setting data
         via the Storefront GraphQL API (see loadDiamond()), not a Liquid-rendered
         product page, so window.currentProductVideoUrl / #product-video (maintained
         by custom-video-player.js on classic product pages) are never populated here
         — look the video up directly from the product_videos metafield map fetched
         alongside the product, keyed the same way custom-video-player.js does. */
      var videoUrl = this.getCurrentSettingVideoUrl();
      if (videoUrl) {
        sessionStorage.setItem("selectedSettingVideo", videoUrl);
      } else {
        sessionStorage.removeItem("selectedSettingVideo");
      }

      /* set selected setting options */
      var settingOptions = {
        settingId: this.diamond.diamondId,
        settingMetal: this.diamond.settingMetal,
        settingSize: this.diamond.settingSize,
        settingCountry: this.defaultSettingCountry,
        settingDiamondShape: this.diamond.diamondShape,
      };
      sessionStorage.setItem(
        "selectedSettingOptions",
        JSON.stringify(settingOptions)
      );
      sessionStorage.removeItem("settingMetal");
      sessionStorage.removeItem("settingDiamond");
      sessionStorage.removeItem("ring_size");
    },
    handleSettingMsgAndRout(isSelectedDiamondRested) {
      // this.diamond.showTooltip = true
      this.diamond.wishlistText = "Setting selected";
      this.diamond.wishlistClass = "tps_ring_selected";
      // Both setting and diamond are now selected — redirect to final-ring
      // instantly, with no artificial delay (unlike the other branches below,
      // which still wait to let their toast/tooltip messages show).
      if (!isSelectedDiamondRested && sessionStorage.getItem("selectedDiamond")) {
        this.diamond.showTooltip = false;
        this.bandPlusRingBtnText = "Redirecting to Review page";
        var selectedDiamond = JSON.parse(
          sessionStorage.getItem("selectedDiamond")
        );
        // Safety net: saveCurrentSetting() (called just before this) should already
        // have written selectedSettingVideo, but recompute here too in case that ran
        // before this page's video metafield had finished loading.
        if (!sessionStorage.getItem("selectedSettingVideo")) {
          var recomputedVideo = this.getCurrentSettingVideoUrl();
          if (recomputedVideo) sessionStorage.setItem("selectedSettingVideo", recomputedVideo);
        }
        // No data= payload here: saveCurrentSetting() (called just before this)
        // already wrote the full setting object to sessionStorage.selectedSetting,
        // plus settingSize/settingMetal to selectedSettingOptions and the video to
        // selectedSettingVideo — final-ring's mounted() reads all of that first.
        // Appending the full payload to the URL too risked a 414 (Request-URI Too
        // Large) on rich settings; nothing is lost by leaving it out here since
        // this is a same-browser redirect, not a cross-device link.
        // Always land on /collections/final-ring regardless of whether this setting
        // was reached via /collections/... or /pages/... — a hard navigation
        // (not router.push) is required to cross that base-path boundary.
        // buildFinalRingUrl (ring-builder-common-components.js) is the single source
        // of truth for this URL's shape, shared with the header steps bar's "View"
        // link/click — so this redirect always matches finalRingHref exactly.
        var href = buildFinalRingUrl({
          settingId: this.diamond.diamondId,
          diamondId: selectedDiamond.diamondId,
          diamondType: selectedDiamond.diamondType,
        });
        if (href) window.location.href = `${baseUrl}${href}`;
        return;
      }
      setTimeout(() => {
        this.diamond.showTooltip = false;
        firstPage = sessionStorage.getItem("firstPage");
        if (isSelectedDiamondRested) {
          if (firstPage == "settingPage") {
            this.$router.push({
              name: "chooseDiamonds",
              params: { diamondType: "natural-diamonds" },
            });
          } else {
            let selectedDiamond = this.selectedDiamondArr?.diamondType;
            let selectedRing = JSON.parse(
              sessionStorage.getItem("selectedSettingOptions")
            )?.settingDiamondShape.toLowerCase();
            this.$router.push({
              path: `/${
                selectedDiamond == "white" ? "natural-diamonds" : selectedDiamond == "lab" ? "lab-diamonds" : selectedDiamond == "white_color" ? "natural-fancy-coloured-diamonds" : selectedDiamond == "lab_color" ? "coloured-lab-grown-diamonds" : ""
              }/${selectedRing}`,
            });
          }
        } else {
          this.bandPlusRingBtnText = "Redirecting to Diamond page";
          var componentName = "chooseDiamonds";
          this.$router.push({ path: `/lab-diamonds` });
        }
      }, 2000);
    },
    handleStepData(setting = "") {
      var firstPage = sessionStorage.getItem("firstPage");
      if (sessionStorage.getItem("stepData")) {
        this.stepData = JSON.parse(sessionStorage.getItem("stepData"));
      }
      if (firstPage == "settingPage") {
        this.stepData.firstStep.headerTitle = "SETTING";
        this.stepData.secondStep.headerTitle = "DIAMOND";
        /* handle setting price for first step */
        this.stepData.firstStep = this.getConvertedStepPrice(
          this.stepData.firstStep
        );
        /* handle diamond price for second step */
        this.stepData.secondStep = this.getConvertedStepPrice(
          this.stepData.secondStep
        );
      } else if (firstPage == "diamondPage") {
        this.stepData.firstStep.headerTitle = "DIAMOND";
        this.stepData.secondStep.headerTitle = "SETTING";
        /* handle setting price for second step */
        this.stepData.secondStep = this.getConvertedStepPrice(
          this.stepData.secondStep
        );
        /* handle diamond price for first step */
        this.stepData.firstStep = this.getConvertedStepPrice(
          this.stepData.firstStep
        );
      }
      /* handle third step as per currency */
      this.stepData.thirdStep = this.getConvertedStepPrice(
        this.stepData.thirdStep
      );
      if (setting) {
        /* handle first and second steps */
        if (firstPage == "diamondPage") {
          this.stepData.secondStep["title"] =
            setting.name.slice(0, 32) + (setting.name.length > 33 ? "..." : "");
          this.stepData.secondStep["price"] = `${setting.currency}${parseFloat(
            setting.price
          ).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
          this.stepData.secondStep["isView"] = true;
          this.stepData.secondStep["isChange"] = true;
          this.stepData.secondStep["id"] = setting.id;
          this.stepData.secondStep["handle"] = setting.handle || "";
          this.stepData.secondStep["page"] = "setting";
          this.stepData.secondStep["imgUrl"] = setting.main_image;
          this.stepData.secondStep["placeholder"] = setting.main_image;
          this.stepData.secondStep = appendCurrenciesToSteps(
            this.stepData.secondStep,
            setting
          );
        } else {
          this.stepData.firstStep["title"] =
            setting.name.slice(0, 32) +
            (setting.name.length > 33 ? "..." : "");
          this.stepData.firstStep["price"] = `${setting.currency}${parseFloat(
            setting.price
          ).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
          this.stepData.firstStep["isView"] = true;
          this.stepData.firstStep["isChange"] = true;
          this.stepData.firstStep["id"] = setting.id;
          this.stepData.firstStep["handle"] = setting.handle || "";
          this.stepData.firstStep["page"] = "setting";
          this.stepData.firstStep["imgUrl"] = setting.main_image;
          this.stepData.firstStep["placeholder"] = setting.main_image;
          this.stepData.firstStep = appendCurrenciesToSteps(
            this.stepData.firstStep,
            setting
          );
        }
        /* handle third step */
        this.handleThirdStep(setting);
        sessionStorage.setItem("stepData", JSON.stringify(this.stepData));
      }
      /* calculate totalSteps based on which steps actually have selections */
      var count = 0;
      if (this.stepData.firstStep && this.stepData.firstStep.title) count++;
      if (this.stepData.secondStep && this.stepData.secondStep.title) count++;
      if (this.stepData.thirdStep && this.stepData.thirdStep.title) count++;
      /* ensure current step (setting) is at least highlighted */
      var fp = sessionStorage.getItem("firstPage");
      var currentStepPos = (fp == "diamondPage") ? 2 : 1;
      this.totalSteps = Math.max(count, currentStepPos);
    },
    getConvertedStepPrice(step) {
      if (step.hasOwnProperty("price")) {
        step = getCurrencyWiseStep(step);
      }
      return step;
    },
    handleThirdStep(setting) {
      if (sessionStorage.getItem("selectedDiamond")) {
        var setting = setting;
        var diamond = JSON.parse(sessionStorage.getItem("selectedDiamond"));
        var stepTitle = `${setting.name} With ${getDiamondTitle(diamond, diamond.diamondType)}`;
        this.stepData.thirdStep["title"] = stepTitle;
        this.stepData.thirdStep["price"] = `${diamond.currencySymbol}${(
          parseFloat(diamond.finalPrice) + parseFloat(setting.price)
        ).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
        this.stepData.thirdStep["isReset"] = true;
        this.stepData.thirdStep["isView"] = true;
        this.stepData.thirdStep["id"] = "";
        this.stepData.thirdStep["page"] = "ring";
        this.stepData.thirdStep["diamondId"] = diamond.diamondId;
        this.stepData.thirdStep["diamondType"] = diamond.diamondType;
        this.stepData.thirdStep["settingId"] = setting.id;
        this.stepData.thirdStep["imgUrl"] = setting.main_image;
        this.stepData.thirdStep = appendCurrenciesToFinalSteps(
          this.stepData.thirdStep,
          diamond,
          setting
        );
      } else {
        this.stepData.thirdStep.headerTitle = "Ring";
      }
    },
    handleStickyBarItems(setting = "") {
      var sessionStickyBarItems = [];
      if (sessionStorage.getItem("stickyBarItems")) {
        sessionStickyBarItems = JSON.parse(
          sessionStorage.getItem("stickyBarItems")
        );
      }
      if (setting) {
        var settingData = {
          title:
            setting.name.slice(0, 32) +
            (setting.name.length > 33 ? "..." : ""),
          page: "setting",
          imgUrl: setting.main_image,
          placeholder: setting.main_image,
          price: `${setting.currency}${parseFloat(setting.price).toLocaleString(
            "en-US",
            { minimumFractionDigits: 2 }
          )}`,
          id: setting.id,
          metal: this.diamond.settingMetal,
          size: this.diamond.settingSize,
          sku: this.diamond.data.sku,
          style: this.diamond.attributes.Engagement_Ring_Style,
        };
        settingData = appendCurrenciesToStickyBarItems(settingData, setting);
        if (!sessionStickyBarItems.length) {
          sessionStickyBarItems.push(settingData);
        } else if (
          sessionStickyBarItems.length < 2 &&
          sessionStickyBarItems.length > 0
        ) {
          for (var index in sessionStickyBarItems) {
            if (sessionStickyBarItems[index].page != "setting") {
              sessionStickyBarItems.push(settingData);
            } else {
              sessionStickyBarItems[index] = settingData;
            }
          }
        } else {
          for (var index in sessionStickyBarItems) {
            if (sessionStickyBarItems[index].page == "setting") {
              sessionStickyBarItems[index] = settingData;
            }
          }
        }
        sessionStorage.setItem(
          "stickyBarItems",
          JSON.stringify(sessionStickyBarItems)
        );
      }
      this.pageStickyItems = this.getConvertedStickyBarItems(
        sessionStickyBarItems
      );
    },
    getConvertedStickyBarItems(stickyBarItems) {
      if (stickyBarItems.length) {
        stickyBarItems.map((stickyBarItem) => {
          if (stickyBarItem.hasOwnProperty("price")) {
            stickyBarItem = getCurrencyWiseStickyItem(stickyBarItem);
          }
        });
      }
      return stickyBarItems;
    },
    setCurrentConfigOptions(settingVariations) {
      var currentSettingId = this.diamond.diamondId;
      for (var variationSlug in settingVariations) {
        if (settingVariations[variationSlug].variation_id == currentSettingId) {
          this.diamond.mainDiamondShape =
            settingVariations[variationSlug].diamond.trim();
          this.diamond.diamondShape =
            settingVariations[variationSlug].diamond.trim();
          this.diamond.settingMetal =
            settingVariations[variationSlug].metal.trim();
          this.diamond.settingMetalToChange =
            settingVariations[variationSlug].metal.trim();
          break;
        }
      }
    },
    handleMetaList(metalList) {
      if (metalList.length) {
        metalList.sort(function (a, b) {
          if (a > b) return 1;
          if (a < b) return -1;
          return 0;
        });
        metalList.map((metalLabel) => {
          this.diamond.settingMetalList.push(metalLabel.trim());
        });
      }
    },
    handleDiamondShape(diamondShapes) {
      if (diamondShapes.length) {
        diamondShapes.map((diamondShape) => {
          this.diamond.diamondShapes.push(diamondShape.trim());
        });
      }
    },
    handleMediaGallery(data) {
      if (!!data) return;
      const {variants,media} = data;
      

      if (!this.diamond.settingMetalToChange) {
        this.diamond.settingMetalToChange = variants.node[0].option1;
      }

      const mediaData = {
        images: media
          .filter((image) => {
            // Normalize alt values for comparison
            const normalizedAlt = ["Platinum", "14k White"].includes(image.alt)
              ? "14k White/Platinum"
              : image.alt;
            const normalizedSetting = ["Platinum", "14k White"].includes(
              this.diamond.settingMetalToChange
            )
              ? "14k White/Platinum"
              : this.diamond.settingMetalToChange;

            return normalizedAlt
              .toLowerCase()
              .includes(normalizedSetting.toLowerCase());
          })
          .map((image) => ({
            src: image.src,
            caption: image.alt,
          })),
      };

      this.diamond.mediaGallery = mediaData;
      // if (this.diamond.mediaGallery.length == 7) break
    },
    getPageUrl() {
      return `${baseUrl}/collections/engagement-rings/settings/${this.$route.params.settingId}`;
    },
    getMetaData(type) {
      const diamond = this.diamond.data;
      switch (type) {
        case "description":
          return `${diamond.name} in ${this.diamond.settingMetal} engagement ring - Demo Jewellery Shop`;
        case "imgUrl":
          return diamond.main_image;
        case "title":
          let title;
          if (!Object.keys(diamond).length) {
            title = "No Setting Found";
          } else {
            title = `${diamond.name} in ${this.diamond.settingMetal}`;
          }
          return title;
        case "siteName":
          return "Vue Woocomerce";
        case "type":
          return "product";
        case "sku":
          return diamond.sku;
        case "category":
          return "Diamond Setting";
        case "price":
          return diamond.price;
        case "currency":
          return "AUD";
        case "availability":
          return diamond.stock_status == "instock"
            ? "in stock"
            : "out of stock";
        case "id":
          return diamond.id;
        case "googleCategory":
          return "Apparel & Accessories > Jewelry > Rings";
      }
    },
    handleMetaData() {
      // document.title = this.getMetaData("title");
      /* set default and openGraph meta data for filter page */
      const meta = [
        { name: "description", content: this.getMetaData("description") },
        { property: "og:title", content: this.getMetaData("title") },
        { property: "og:site_name", content: this.getMetaData("siteName") },
        { property: "og:type", content: this.getMetaData("type") },
        { property: "og:url", content: this.getPageUrl() },
        { property: "og:image", content: this.getMetaData("imgUrl") },
        {
          property: "og:description",
          content: this.getMetaData("description"),
        },
        { property: "og:sku", content: this.getMetaData("sku") },
        { property: "og:category", content: this.getMetaData("category") },
        { property: "og:price:amount", content: this.getMetaData("price") },
        {
          property: "og:price:currency",
          content: this.getMetaData("currency"),
        },
        {
          property: "og:availability",
          content: this.getMetaData("availability"),
        },
        { property: "og:id", content: this.getMetaData("id") },
        {
          property: "og:google_product_category",
          content: this.getMetaData("googleCategory"),
        },
      ];
      const link = [{ rel: "canonical", href: this.getPageUrl() }];
      // setMetaData("meta", meta);
      // setMetaData("link", link);
    },
    handleBtnTooltip(action, btnType) {
      var tooltipTxt;
      if (btnType == "add to cart") {
        tooltipTxt =
          action == "show" ? "Please Select Engagement Ring Size First" : "";
        btnTooltipClass = action == "show" ? "pc-buy-setting" : "";
      } else {
        tooltipTxt =
          action == "show" ? this.$options.chooseSettingTooltipTxt : "";
        btnTooltipClass = action == "show" ? "pc-choose-setting" : "";
      }
      this.btnTooltipText = tooltipTxt;
      this.btnTooltipClass = btnTooltipClass;
      this.showBtnTooltip = action == "show" ? true : false;
    },
    navigateToBracelet() {
      window.open(`${baseUrl}/fine-jewelry/bands`, "_blank");
    },
    BandAddToCart(matching) {
      sessionStorage.setItem("selectedWeddingBand", JSON.stringify(matching));
    },
    ringAndBandCart(matching) {
      if (
        document
          .querySelector(".pc-ring_size_spacer .pc-dropbtn")
          .innerText.includes("Select Ring Size")
      ) {
        // this.$refs.pc-ring-size-spacer.scrollIntoView({ behavior: 'smooth' });
        if (window.innerWidth > 991) {
          document
            .querySelector("#setting-meta-data-big-screen #pc-choose-metal")
            .scrollIntoView({ behavior: "smooth" });
          document.querySelector(
            "#setting-meta-data-big-screen #pc-ring-size-spacer-inside"
          ).style.border = "3px solid red";
          document.querySelector(
            "#setting-meta-data-big-screen #pc-ring-size-spacer-inside"
          ).style.padding = "5px";
        } else {
          document
            .querySelector("#setting-meta-data-tablet-screen #pc-choose-metal")
            .scrollIntoView({ behavior: "smooth" });
          document.querySelector(
            "#setting-meta-data-tablet-screen #pc-ring-size-spacer-inside"
          ).style.border = "3px solid red";
          document.querySelector(
            "#setting-meta-data-tablet-screen #pc-ring-size-spacer-inside"
          ).style.padding = "5px";
        }
        this.handleBtnTooltip("show", "add to cart");
        setTimeout(() => {
          this.handleBtnTooltip("hide", "add to cart");
          setTimeout(() => {
            if (window.innerWidth > 991) {
              document.querySelector(
                "#setting-meta-data-big-screen #pc-ring-size-spacer-inside"
              ).style.border = "3px solid transparent";
              document.querySelector(
                "#setting-meta-data-big-screen #pc-ring-size-spacer-inside"
              ).style.padding = "5px";
            } else {
              document.querySelector(
                "#setting-meta-data-tablet-screen #pc-ring-size-spacer-inside"
              ).style.border = "3px solid transparent";
              document.querySelector(
                "#setting-meta-data-tablet-screen #pc-ring-size-spacer-inside"
              ).style.padding = "5px";
            }
          }, 3000);
        }, 2000);
      } else {
        this.bandPlusRingBtnText = "Ring and Band is Selected";
        this.BandAddToCart(matching);
        this.addCurrentSetting();
        document.getElementById("pc-ring-size-spacer-inside").style.border = "";
        document.getElementById("pc-ring-size-spacer-inside").style.padding =
          "";
      }
    },
    navigateBlank(url) {
      window.open(url, "_blank");
    },
  },
  beforeMount() {
    document.getElementById("initial-page-loader").style.display = "none";
    let elements = document.getElementsByClassName("js-recently-view");
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.display = "block";
    }
  },
};
